import linkViewModel from '@vimcar/mvvm/linkViewModel'
import IForm from '@vimcar/shared-components/components/IForm/'
import NumberField from '@vimcar/shared-components/components/IForm/components/NumberField'
import Paragraph from '@vimcar/shared-components/components/Paragraph'
import * as React from 'react'

import type { ViewState } from '../Root/viewModel'
import type { ViewModel } from './viewModel'

import i18n from '../../utils/i18n'
import BottomActions from '../BottomActions'
import StepContent from '../StepContent'
import styles from './styles.css'
import mkViewModel from './viewModel'

const tp = i18n.prefixWithoutTestId('CustomNumberOfCars')

type Props = {
  state: ViewState
  viewModel: ViewModel
}

const CustomNumberOfCars = ({ state, viewModel }: Props) => (
  <React.Fragment>
    <StepContent>
      <Paragraph className={styles.title} variant='subtitle1'>
        {state.currentNode.text}
      </Paragraph>
      <Paragraph variant='body2'>{state.currentNode.subtext}</Paragraph>
      <div className={styles.formContainer}>
        {/* @ts-expect-error@2322 */}
        <IForm
          className={styles.form}
          onChange={viewModel.handleFormChange}
          onValid={viewModel.handleFormValid}
        >
          <NumberField
            label={tp('number-cars')}
            property='numberOfCars'
            required
          />
        </IForm>
      </div>
    </StepContent>
    <BottomActions
      // @ts-expect-error@2322
      nextEnabled={viewModel.isValid}
      onBack={viewModel.handleBack}
      onNext={viewModel.handleNext}
      showBack
    />
  </React.Fragment>
)

const component = linkViewModel(mkViewModel, CustomNumberOfCars)
component.displayName = 'CustomNumberOfCars'
export default component
